export default [
  {
    path: 'audit-update-template-renew/:auditId',
    name: 'auditRenewTemplateAndUpdate',
    component: () => import('@/views/Audit/RenewTemplateAndUpdate.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-audits',
      template: 'auth',
    },
  },
  {
    path: 'board/audit-questions/:auditId',
    name: 'boardAuditQuestions',
    component: () => import('@/views/Audit/Questions.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'board-audit-questions',
      template: 'auth',
    },
  },
  {
    path: 'board/auditee-reply/:recordId',
    name: 'boardAuditReply',
    component: () => import('@/views/Audit/Reply.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'board-audit-reply',
      template: 'auth',
    },
  },
  {
    path: 'board/auditer-result/:recordId',
    name: 'boardAuditResult',
    component: () => import('@/views/Audit/Result.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'board-audit-result',
      template: 'auth',
    },
  },
  {
    path: 'printing/audit-result',
    name: 'PrintingAuditResult',
    component: () => import('@/views/Printing/AuditResult.vue'),
    props: true,
    meta: {
      name: 'printing-task',

      middleware: 'auth',
      template: 'printing',
    },
  },
  {
    path: 'create-audit-survey',
    name: 'AuditSurveyCreate',
    component: () => import('@/views/Audit/AuditSurvey/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-audits',
      template: 'auth',
    },
  },
  {
    path: 'update-audit-survey/:auditSurveyId',
    name: 'AuditSurveyUpdate',
    component: () => import('@/views/Audit/AuditSurvey/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-audits',
      template: 'auth',
    },
  },
  {
    path: 'audits',
    name: 'audits',
    component: () => import('@/views/Audit/Index.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-audit',
      template: 'auth',
    },
  },
  {
    path: 'audit-content/:auditId',
    name: 'auditContent',
    component: () => import('@/views/Audit/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-audit',
      template: 'auth',
    },
  },
  {
    path: 'audit-template-content/:templateId',
    name: 'auditTemplateContent',
    component: () => import('@/views/Audit/ShowTemplate.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-audit',
      template: 'auth',
    },
  },
  {
    path: 'audit-create/:auditTemplateId',
    name: 'auditCreate',
    component: () => import('@/views/Audit/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-audit',
      template: 'auth',
    },
  },
  {
    path: 'audit-update-basic/:auditId',
    name: 'auditUpdate',
    component: () => import('@/views/Audit/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-audit',
      template: 'auth',
    },
  },
  {
    path: 'audit/:auditId/audit-update-template-renew',
    name: 'auditUpdateTemplateRenew',
    component: () => import('@/views/Audit/RenewTemplateAndUpdate.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-audit',
      template: 'auth',
    },
  },
  {
    path: 'audit-assignment/:requestId',
    name: 'auditAssignment',
    component: () => import('@/views/Audit/Assignment.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'board-audit-assignment',
      template: 'auth',
    },
  },
  {
    path: 'audit-question-content/:auditId',
    name: 'auditQuestionContent',
    component: () => import('@/views/Audit/Questions.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'board-audit-question',
      template: 'auth',
    },
  },
  {
    path: 'auditee-reply-content/:recordId',
    name: 'auditReplyContent',
    component: () => import('@/views/Audit/Reply.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'board-audit-reply',
      template: 'auth',
    },
  },
  {
    path: 'auditer-result/:recordId',
    name: 'auditResult',
    component: () => import('@/views/Audit/Result.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'board-audit-result',
      template: 'auth',
    },
  },
  {
    path: 'print-audit-result',
    name: 'printAuditResult',
    component: () => import('@/views/Printing/AuditResult.vue'),
    props: true,
    meta: {
      name: 'printAuditResult',
      middleware: 'auth',
      template: 'printing',
    },
  },
  {
    path: 'audit-survey-content/:auditSurveyId',
    name: 'auditSurveyShow',
    component: () => import('@/views/Audit/AuditSurvey/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-audit',
      template: 'auth',
    },
  },
  {
    path: 'audit-survey-create',
    name: 'auditSurveyCreate',
    component: () => import('@/views/Audit/AuditSurvey/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-audit',
      template: 'auth',
    },
  },
  {
    path: 'audit-survey-update/:auditSurveyId',
    name: 'auditSurveyUpdate',
    component: () => import('@/views/Audit/AuditSurvey/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-audit',
      template: 'auth',
    },
  },
  {
    path: 'audit-paper-action-content/:auditActionId',
    name: 'auditPaperActionContent',
    component: () => import('@/views/Audit/AuditSurvey/AuditPaper/ActionShow.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-audit',
      template: 'auth',
    },
  },
];
